import { ReactNode } from 'react';
import { cn } from '@/lib/utils';

type Props = {
  children: ReactNode;
  label: string;
  className?: string;
};

const OfferPricingCard = ({ children, label, className }: Props) => (
  <div
    className={cn(
      'rounded-lg border border-border bg-card p-4 flex flex-col items-start gap-1',
      className
    )}
  >
    <p className="text-sm text-foreground mb-1">{label}</p>
    <>{children}</>
  </div>
);

export default OfferPricingCard;
